import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelWarningModalComponent } from './travel-warning-modal.component';
import { BariModalModule } from '@bari/shared/components/bari-modal/bari-modal.module';
import { TravelWarningModalRoutingModule } from './travel-warning-modal.routing';
import { BariButtonModule } from '@bari/shared/components/bari-button/bari-button.module';
import { CreditCardService } from '@bari/core/services/credit-card.service';

@NgModule({
  declarations: [TravelWarningModalComponent],
  imports: [
    CommonModule,
    BariModalModule,
    TravelWarningModalRoutingModule,
    BariButtonModule
  ],
  providers: [CreditCardService]
})
export class TravelWarningModalModule {}
